import { first, map } from 'rxjs/operators';
import Router from 'vue-router';

import { AuthService } from '@skinsoft/auth';
import { Login } from '@skinsoft/auth-ui'

import { router as unifiedRouter } from '../../../reporter-launcher/src/router' // TODO better'
import { RecordSearchScreen } from './app/component/audit-campaign-records/record-search-screen';
import { AuditCampaignSearchMenu } from './app/component/audit-campaign-search/audit-campaign-search-menu';
import { AuditCampaignSearchScreen } from './app/component/audit-campaign-search/audit-campaign-search-screen';
import { RecordEditScreen } from './app/component/record-edit-screen';
import { RecordEditMenu } from './app/component/record-edit-screen/record-edit-menu';
import { ItemSearchScreen } from '../../../lib/@skinsoft/search/src/search-screen/item-search-screen'
import { SoloItemEditScreen } from '@skinsoft/entity-ui/src/item/components/solo-item-edit-screen'
import { AuditItemEditScreen } from './app/component/audit-item-edit-screen';
import { AuditItemEditMenu } from './app/component/audit-item-edit-screen/audit-item-edit-menu';

declare var UNIFY_ROUTER: boolean;

export enum Routes {
    AUDIT_HOME = 'auditHome',
    CAMPAIGN_SEARCH = 'campaigns',
    LOGIN = 'login',
    CAMPAIGN = 'campaign',
    RECORD = "record",
    ITEM = 'item',
    NEW_ITEMS = 'newItems'
}

const routes = [
    {
        component: ItemSearchScreen,
        name: Routes.AUDIT_HOME,
        path: '/auditHome',
        props: {
            titleI18NKey: "auditCampaignSearchScreen.title",
            canCreateObject: true,
            displayedButtons: [
                {
                    type: 'camera',
                    icon: 'camera',
                    class: 'new-cr-from-scratch'
                },
                {
                    type: 'modifyItemRecord',
                    icon: 'edit',
                    class: 'new-cr-from-last'
                }
            ],
            targetRouteName: Routes.ITEM,
            onlyUploaded: true
        }
    },
    {
        component: AuditCampaignSearchScreen,
        name: Routes.CAMPAIGN_SEARCH,
        path: '/campaigns',
        props: {
            titleI18NKey: "auditCampaignSearchScreen.title"
        }
    },
    {
        components: {
            actionMenu: AuditCampaignSearchMenu,
            default: RecordSearchScreen,
        },
        name: Routes.CAMPAIGN,
        path: '/campaign/:campaignId',
    },
    {
        components: {
            actionMenu: RecordEditMenu,
            default: RecordEditScreen,
        },
        name: Routes.RECORD,
        path: '/record/:campaignId/:recordId',
        props: {
            default: true
        }
    },
    {
        components: {
            actionMenu: AuditItemEditMenu,
            default: SoloItemEditScreen,
        },
        name: Routes.ITEM,
        path: '/item/:itemId',
        props: {
            default: route => ({
                itemId: route.params.itemId,
                itemEditScreen: AuditItemEditScreen,
                routes: {
                    offlineRoute: Routes.NEW_ITEMS,
                    onlineRoute: Routes.AUDIT_HOME
                }
            }),
        }
    },
    {
        
        component: ItemSearchScreen,
        name: Routes.NEW_ITEMS,
        path: '/newItems',
        props: {
            onlyNewItems: true,
            canCreateObject: true,
            displayedButtons: [
                {
                    type: 'camera',
                    icon: 'camera',
                    class: 'new-cr-from-scratch'
                },
                {
                    type: 'modifyItemRecord',
                    icon: 'edit',
                    class: 'new-cr-from-last'
                }
            ],
            targetRouteName: Routes.ITEM
        }
    },
    { path: '*', redirect: '/auditHome' }
]

// tslint:disable-next-line:variable-name
let _router: Router;

// If app is embedded in launcher, use launcher router
if (UNIFY_ROUTER) {
    _router = unifiedRouter
}
// If app is standalone, use its own router
else {
    _router = new Router({
        mode: 'history',
    });
    routes.push()
    _router.addRoutes([{
        component: Login,
        name: Routes.LOGIN,
        props: {
            homeRoute: Routes.AUDIT_HOME
        },
        path: '/login',
    }])
}
_router.addRoutes(routes)

export const router = _router;

router.beforeEach((to, __, next) => {
    AuthService.getInstance()
        .waitForUser$()
        .pipe(
            first(),
            map(authenticated => {
                if (!(authenticated && authenticated.user) && to.name !== Routes.LOGIN) {
                    return { name: Routes.LOGIN };
                }

                if (authenticated && authenticated.user && to.name === Routes.LOGIN) {
                    return false;
                }

                return;
            }),
        )
        .subscribe(next);
});
